// ProjectStrips — the SESSION's strips of a frame's pinned top (`ShellTop`),
// broadest on top: the person's (the time-zone drift question — the whole
// session is broader than any project) over the project's. Always visible — pinned with the bar, never scrolled away:
// each says something true about the whole SESSION or the WHOLE project on every
// page of it, a wizard included (FRONTEND-PATTERNS §Navigation / shell). Both project frames mount
// this ONE piece (AuthedLayout · FocusedLayout), so a new project-scope strip
// lands in every frame at once.
//
// A strip here is PERSISTENT chrome, and a frame switch (page ⇄ wizard) mounts
// it already filled in — so it is a polite `role="status"` at most, NEVER an
// assertive `role="alert"` (Banner's warning / danger variants): an alert pinned
// to every page would be spoken on every entry.
//
// Each strip decides for itself whether it shows; this piece owns only the
// order. (An ENTITY-scope lifecycle banner is not one of these — it rides above
// the entity header and scrolls away with it.)

import { CannotRefreshBand } from './CannotRefreshBand.js';
import { ProjectBanner } from './ProjectBanner.js';
import { TimezoneDriftStrip } from './TimezoneDriftStrip.js';

export function ProjectStrips({ driftBrowser }: { /** Stories only — pins the drift strip's browser zone (otherwise the runtime's). */ driftBrowser?: string } = {}) {
  return (
    <>
      <TimezoneDriftStrip browser={driftBrowser} />
      <CannotRefreshBand />
      <ProjectBanner />
    </>
  );
}
